import { useState } from "react";

export default function YourKitchenForm({ prefs, onSubmit, btnText }) {
    const [form, setForm] = useState({
      pantryLevel: prefs.pantryLevel,
    });
    const buttonText = btnText || "Save";
    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit({ ...prefs, ...form });
    };
  
    return (
      <form onSubmit={handleSubmit} className="space-y-4">
        <SelectField
          label="How well stocked is your kitchen?"
          name="pantryLevel"
          value={form.pantryLevel}
          onChange={handleChange}
          options={[
            { value: "basic", label: "Basic: Salt & pepper but not much more than this" },
            { value: "everyday", label: "Everyday: Staples like a few herbs, spices and basic ingredients" },
            { value: "well-stocked", label: "Well-Stocked: Good selection of common ingredients, herbs, and spices" },
            { value: "pro-kitchen", label: "Pro Kitchen: Fully stocked, virtually nothing is off-limits" },
          ]}
        />
        <button className="w-full bg-sage text-white py-2 rounded-3xl hover:bg-sagedark">{buttonText}</button>
      </form>
    );
  }
  
  function SelectField({ label, options, ...props }) {
    return (
      <label className="block">
        <span className="block mb-1">{label}</span>
        <select {...props} className="w-full bg-white p-2 border rounded">
          {options.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </label>
    );
  }
  